import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CenterContainer from "../../../components/centerContainer/CenterContainer";
import Spinner from "../../../components/spinner/Spinner";
import { GetSalesBusiness, StoreSalesBusiness } from "../../../utils/StorageUtil";
import "./../businessProfileConnect/BusinessProfileConnect.css";
import { toast } from "react-toastify";
import { Fragment } from "react";
import { parseAddressFromGoogleProfile } from "../../../utils/Common";
import GoogleBusinessAutoComplete from "../googleBusinessAutoComplete/GoogleBusinessAutoComplete";
import { CreateSalesCompany, RegisterUser } from "../../../Services";
import { useStateValue } from "../../../StateProvider";

const BusinessProfileAddress = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedBusiness, setSelectedBusiness] = useState();
    const navigate = useNavigate();
    const location = useLocation();
    const [isNewBusiness, setIsNewBusiness] = useState(false);
    const [{ user, defaultPage }, dispatch] = useStateValue();

    useEffect(() => {
        if (location.pathname.indexOf("/new") > -1) {
            setIsNewBusiness(true);
        }
    }, [location]);

    const handlePlaceSelected = async (place) => {
        if (place) {
            let tempBusiness = GetSalesBusiness();
            let addressData = parseAddressFromGoogleProfile(place.address_components);

            setSelectedBusiness({
                ...tempBusiness,
                ...addressData,
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            });
        }
    };

    const handleAddressChange = (e) => {
        if (!e.target || !e.target.value || e.target.value.trim() === "") {
            setSelectedBusiness({
                ...selectedBusiness,
                streetAddress1: null,
                city: null,
                state: null,
                postalCode: null,
                country: null,
            });
        }
    };

    const handleAddressSetup = async (e) => {
        e.preventDefault();

        if (!selectedBusiness.streetAddress1 || !selectedBusiness.streetAddress1.trim === "") {
            toast.error("Location or address is required");
            return;
        }

        let tempSelectedBusiness = { ...selectedBusiness };

        StoreSalesBusiness(tempSelectedBusiness);

        //should we create a new user?
        if (!tempSelectedBusiness.userId || tempSelectedBusiness.userId === "0") {
            let userEmail, firstName, lastName;
            userEmail =
                tempSelectedBusiness.name
                    .toLowerCase()
                    .replace(/ /g, "")
                    .replace(/[^\w-]+/g, "") + "@realwebsite.com";

            let nameArgs = tempSelectedBusiness.name.split(" ");
            if (nameArgs && nameArgs.length > 1) {
                firstName = nameArgs[0];
                lastName = tempSelectedBusiness.name.replace(firstName, "").trim();
            } else {
                firstName = tempSelectedBusiness.name;
            }

            //create user
            let userData = {
                email: userEmail,
                password: "pa$$w0rd",
                firstName: firstName,
                lastName: lastName,
                phone: tempSelectedBusiness.formatted_phone_number,
                status: "Active",
                billingId: null,
                parentUserId: null,
            };

            const userResponse = await RegisterUser(userData);

            if (userResponse && userResponse.id) {
                tempSelectedBusiness.userId = userResponse.id;

                StoreSalesBusiness(tempSelectedBusiness);
            }
        }

        //create new business record and redirect to business list
        let businessEmail =
            tempSelectedBusiness.name
                .toLowerCase()
                .replace(/ /g, "")
                .replace(/[^\w-]+/g, "") + "@realwebsite.com";

        //first create company if it doesn't exist
        let companyData = {
            ...tempSelectedBusiness,
            //userId: user.id,
            userId: tempSelectedBusiness.userId ? tempSelectedBusiness.userId : user.id,
            salesRepId: user.isSalesUser ? user.id : null,
            email: businessEmail,
            phone: tempSelectedBusiness.formatted_phone_number,
            googleCid: tempSelectedBusiness.cid,
            googlePlaceId: tempSelectedBusiness.place_id,
            googleBusinessUrl: tempSelectedBusiness.googleBusinessUrl
                ? tempSelectedBusiness.googleBusinessUrl
                : tempSelectedBusiness.cid
                ? "https://maps.google.com/?cid=" + tempSelectedBusiness.cid
                : "",
            status: "Active",
        };

        const companyResponse = await CreateSalesCompany(companyData);

        if (!companyResponse.success) {
            if (companyResponse.data && companyResponse.message.indexOf("already exists") > -1 && companyResponse.data.userId === user.id) {
                toast.error("Business already exists");
                navigate("/profile-connect/new");
                return;
            }
        }

        if (isNewBusiness) {
            navigate(`/${defaultPage}`);
        } else {
            navigate(`/reports/${companyResponse.data.id}/new`);
        }
    };

    return (
        <Fragment>
            <div className="main-content-container business-profile-container">
                <div className="main-content-inner-container">
                    <div className="business-profile-connect-container">
                        {isLoading ? (
                            <Spinner />
                        ) : (
                            <Fragment>
                                <h2 className="mb-3">Enter Your Business Address</h2>
                                <div className="text-start mb-sm-5 mb-4">
                                    Please enter your office or home office address that you either work from, or start from when you leave
                                    to go visit your customers.
                                </div>

                                <div className="mb-3">
                                    <GoogleBusinessAutoComplete onPlaceSelected={handlePlaceSelected} onChange={handleAddressChange} />

                                    {/* <input
									type="text"
									className="form-control"
									placeholder="Enter Address"
									value={address || ''}
									onChange={(e) => setAddress(e.target.value)}
								/> */}
                                </div>
                                <div className="mb-sm-5 mb-4">
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleAddressSetup}
                                        disabled={!selectedBusiness || !selectedBusiness.streetAddress1}
                                    >
                                        Continue
                                    </button>
                                </div>
                                <div className="text-start mb-2 fw-bolder">
                                    <strong>Why do you need my address?</strong>
                                </div>
                                <div className="text-start">
                                    Your business profile is set up as a "Service Area" business and does not have an address listed on the
                                    profile details. We need your address to make sure we center your grid report near what Google believes
                                    if...
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default BusinessProfileAddress;
